import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconRubbishBinSvg } from './IconRubbishBinSvg';

export const IconRubbishBin: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconRubbishBinSvg} {...iconProps} />;
};
